import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrl: './pagination.component.scss',
})
export class PaginationComponent implements OnChanges {
  @Input() totalItems = 64;
  @Input() itemsPerPage = 10;
  @Input() currentPage = 0;
  @Input() pageSizeOptions: number[] = [10, 20, 30, 50, 100];

  @Output() pageChanged = new EventEmitter<number>();
  @Output() itemsPerPageChange = new EventEmitter<number>();

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['totalItems']) {
      this.totalItems = changes['totalItems'].currentValue;
    }
    if (changes['itemsPerPage']) {
      this.itemsPerPage = changes['itemsPerPage'].currentValue;
    }
    if (changes['currentPage']) {
      this.currentPage = changes['currentPage'].currentValue;
    }
  }

  onPageChange(page: number) {
    const maxPage = Math.max(this.totalPages.length - 1, 0);
    const nextPage = Math.max(0, Math.min(page, maxPage));
    this.currentPage = nextPage;
    this.pageChanged.next(nextPage);
  }

  onItemsPerPageChange(size: number) {
    if (size === this.itemsPerPage) {
      return;
    }
    this.itemsPerPageChange.emit(size);
    this.onPageChange(0);
  }

  /** Erste Seite erreicht — Erste/Vorherige greifen nicht. */
  get atStart(): boolean {
    return this.currentPage === 0 || this.totalPages.length === 0;
  }

  /** Letzte Seite erreicht — Nächste/Letzte greifen nicht. */
  get atEnd(): boolean {
    return this.currentPage === this.totalPages.length - 1 || this.totalPages.length === 0;
  }

  get totalPages() {
    const totalPages = Math.ceil(this.totalItems / this.itemsPerPage);
    return new Array(totalPages).fill(0);
  }

  get visiblePages(): number[] {
    const pageCount = this.totalPages.length;
    if (pageCount <= 7) {
      return Array.from({ length: pageCount }, (_, i) => i);
    }

    const start = Math.max(0, Math.min(this.currentPage - 2, pageCount - 5));
    return Array.from({ length: 5 }, (_, i) => start + i);
  }

  trackByFn(index: number, item: any) {
    return index + '-pagination';
  }
}
